import { Tabs } from '@mantine/core';
import { useState } from 'react';
import ConfirmPasscodeForm from './confirm-passcode';
import CreatePasscodeForm from './create-passcode-form';

const Passcode = () => {
  const [tabs, setTabs] = useState<string | null>('create');
  const [passcode, setPasscode] = useState<string>('');
  return (
    <Tabs value={tabs} onChange={setTabs}>
      <Tabs.Panel value="create">
        <CreatePasscodeForm
          onChangePasscode={setPasscode}
          onChangeTabPasscode={setTabs}
        />
      </Tabs.Panel>
      <Tabs.Panel value="confirm">
        <ConfirmPasscodeForm
          passcode={passcode}
          onChangeTabPasscode={setTabs}
        />
      </Tabs.Panel>
    </Tabs>
  );
};

export default Passcode;
